<template lang="pug">
  .boost-module(v-if="selectedBoost && selectedBoost.id")
    transition(name="height")
      .boost-module-wrap(v-if="!maxBoostsAdded")
        .boost-added-message.absolute-wrap.text-center.bg-gray-light(v-if="boostAdded")
          .v-center.full-width
            span.icon-check.color-slate.xs-f-xlarge.max-at-tweak
            p.xs-f-small.max-at-tweak(role="alert") Your item was added to bag

        .boost-module-cta.xs-12(:class="{'boost-added': boostAdded}")
          .boost-intro.xs-12.text-center
            p.xs-f-medium.lg-f-xmedium.max-at-tweak(v-html="introText")

          .boost-product-info.xs-12
            button.btn-reset.checkbox-wrap.full-width(@click="addBoost")
              .mr-checkbox(:class="{selected: boostChecked}")
              span.ada-tooltip add to bag
              img.boost-image(:src="boostImageObj.url" alt="")
              .boost-info
                span.boost-name.upper.xs-f-xsmall.max-at-tweak {{ selectedBoost.name }}
                span.boost-price.bold.xs-f-small.lg-f-medium.max-at-tweak {{ selectedBoost.price | currency }}

          .boost-ctas.xs-12
            button.btn-reset.pull-left.color-purple.xs-f-small.max-at-tweak(@click="showBoostModal") More boosts
            button.btn-reset.pull-right.color-purple.xs-f-small.max-at-tweak(@click="showBoostModal") What's a boost?

</template>

<script>
  import { mapState, mapActions, mapMutations } from "vuex";
  import boostMixin from "../../../../mixins/boostMixin";

  export default {
    name: "BoostModule",

    mixins: [ boostMixin ],

    inject: ['getObjProperty'],

    data() {
      return {
        boostChecked: false,
        boostAdded: false,
        boostsAdded: []
      }
    },

    computed: {
      ...mapState('cart', ['addingProduct']),

      introText() {
        return this.selectedBoost.recommended ? `You mentioned wanting ${this.selectedBoost.wantText}&mdash;add a Pro&nbsp;Boost` : `Want ${this.selectedBoost.wantText}?&mdash;add a Pro&nbsp;Boost`;
      },

      boostImageObj() {
        return this.getObjProperty(this.selectedBoost, "imagery.thumb") || {};
      },

      maxBoostsAdded() {
        return this.boostsAdded.length >= 2 || this.boostsAdded.length >= this.boostRecommendations.length;
      }
    },

    methods: {
      ...mapActions('cart', ['addToCart']),
      ...mapMutations('pdp', ['setAttachableProdId']),

      showBoostModal() {
        this.$store.dispatch('modal/showModal', { component: './Dashboard/Welcome/ReturnCustomer/BoostModal', theme: 'no-padding' }, { root: true });
      },

      addBoost() {
        if (this.boostChecked) {
          return;
        }
        this.boostChecked = true;

        let payload = {
          productId: this.selectedBoost.id,
          ctaSource: 'boost-module',
          cartType: 'active'
        };

        this.addToCart(payload).then(() => {
          this.boostAdded = true;
          this.setAttachableProdId(this.selectedBoost.id);

          setTimeout(() => {
            this.boostChecked = false;
            this.boostAdded = false;
            this.boostsAdded.push(payload.productId);
            
            var nextRecIndex = null;

            for (var x = 0; x < this.boostRecommendations.length; x++) {
              if (nextRecIndex === null && this.boostsAdded.indexOf(this.boostRecommendations[x].id) == -1) {
                nextRecIndex = x;
                break;
              };
            }
            
            if (nextRecIndex != null) {
              this.updateSelectedBoost(nextRecIndex);
            }
          }, 1500);
        }).catch(() => {
          this.boostChecked = false;
          this.boostAdded = false;
        });
      }
    }
  }
</script>

<style scoped lang="stylus">
  .boost-module
    .boost-module-wrap
      max-height 22em
      overflow hidden

      .boost-added-message
        margin auto
        opacity 100
        top 1em
        border-radius 0.5em

        p
          margin-top 1.5em

      .boost-module-cta
        opacity 100
        transition(opacity 300ms ease-in-out)
        background-color color-white
        border 1px solid color-gray-med
        border-radius 0.5em
        margin-top 1em
        
        &.boost-added
          opacity 0
          pointer-events none

        .boost-intro
          padding 1.5em 5%
          border-bottom 1px solid #ccc

        .boost-product-info
          padding 1.5em 5%

          .boost-label
            display block

          .mr-checkbox
          .boost-image
          .boost-info
            display inline-block
            vertical-align top

          .mr-checkbox
            margin-top 2em

          .boost-image
            width 5.5em
            margin-right 1em

          .boost-info
            width 10em
            text-align left

            span
              display block

        .boost-ctas
          padding 1em 5%
          padding-top 0

      @media mq-mobile
        padding 0 5%

        .boost-added-message
          width 90%

        .boost-module-cta
          .boost-product-info
            .boost-info
              width 8em

      @media mq-tablet
        padding 0 10%

        .boost-added-message
          width 80%

        .boost-module-cta
          .boost-product-info
            .boost-info
              width 9em

    .height-enter-active
    .height-leave-active
      transition(max-height 500ms ease-in-out)
      
    .height-enter
    .height-leave-to
      max-height 0
      
</style>
